"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Dependencies (global):
// -> Vuex [QuasarPackage]
// -> Notify [QuasarPlugin]
const vue_1 = require("vue");
const quasar_1 = require("quasar");
const vuex_1 = require("vuex");
//export default {
exports.default = vue_1.defineComponent({
    setup() {
        const $store = vuex_1.useStore();
        const $q = quasar_1.useQuasar();
        return { $store, $q };
    },
    data() {
        return {
            ui_Title: '',
            ui_Loading: false,
            editorToolbarDefault: [
                ['bold', 'italic', 'underline', 'subscript', 'superscript'],
                ['unordered', 'ordered', 'outdent', 'indent'],
                ['left', 'center', 'right', 'justify'],
                ['link', 'removeFormat', 'quote', 'hr'],
                [{
                        label: this.$q.lang.editor.formatting,
                        icon: this.$q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                            //'h1',
                            //'h2',
                            //'h3',
                            //'h4',
                            //'h5',
                            'h6',
                            'p',
                            'code'
                        ]
                    }, /*{
                      label: this.$q.lang.editor.fontSize,
                      icon: this.$q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7'
                      ]
                    }*/
                ],
                ['undo', 'redo'],
                ['viewsource'],
                ['fullscreen']
            ]
        };
    },
    mounted() {
        if (this.$data.ui_Title) { // got title - it is "page view"
            // on page component mounted clear all possible progressbars
            this.progressbar(false);
        }
    },
    methods: {
        /**
         * Flash message to parent (Quasar notify plugin)
         *
         * @param {String} msg
         * @param {string} type: 'positive' | 'negative' | 'info' | 'warning' | 'action'
         * @param {Object} params
         */
        flash(msg, type = 'positive', params = {}) {
            return this.$q.notify(Object.assign({
                message: msg,
                position: 'top',
                color: type !== 'action' ? type : 'amber-10',
                html: true,
                textColor: type === 'warning' ? 'black' : undefined,
                icon: type === 'positive' ? 'check_circle' : type === 'negative' ? 'error' : type === 'info' ? 'info' : (type === 'action' ? 'check_box' : 'warning')
            }, params));
        },
        /**
         * Progressbar (Quasar)
         *
         * @param {boolean} [show=true]
         * @param {Object} [params]
         */
        async progressbar(show = true) {
            if (show) {
                return Promise.resolve(this.$store.dispatch('loadingAdd'));
            }
            else {
                return Promise.resolve(this.$store.dispatch('loadingRemove'));
            }
            //this.$emit('progressbar', { ...{ show: show }, ...params })
            //this.$bus.$emit('progressbar', { ...{ show: show }, ...params })
        },
        /**
         * Select all node text contents
         * @param node  HTML node
         */
        uiSelectAll(node, doc) {
            let range, selection;
            /*if (doc.body.hasOwnProperty('createTextRange')) {
              range = doc.body.createTextRange() //! issue
              range.moveToElementText(node)
              range.select()
            } else */
            if (window.getSelection) {
                selection = window.getSelection();
                range = doc.createRange();
                range.selectNodeContents(node);
                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
        },
        uiUndoAction(msg, execCallback, cancelCallback, timeout = 5000) {
            const timeOutID = 'uiUndoAction' + msg.replace(/[^a-z^0-9]/ig, '');
            if (!window.timeouts) {
                window.timeouts = {};
            }
            this.$q.notify({
                message: msg,
                position: 'top',
                color: 'positive',
                html: true,
                textColor: undefined,
                icon: 'check_circle',
                progress: true,
                timeout: timeout - 1000,
                actions: [
                    {
                        label: 'Undo', color: 'white', handler: () => {
                            clearTimeout(window[timeOutID]);
                            try {
                                cancelCallback();
                            }
                            catch (err) { }
                        }
                    }
                ]
            });
            window[timeOutID] = setTimeout(() => {
                try {
                    execCallback();
                }
                catch (err) { }
            }, timeout);
        },
        /**
         * Quasar QEditor (q-editor) -> prevent pasting formatted content
         * Capture the <CTL-V> paste event, only allow plain-text, no images.
         *
         * see: https://stackoverflow.com/a/28213320
         *
         * @param {object} evt - array of files
         * @author Daniel Thompson-Yvetot
         * @license MIT
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pasteCapture(evt, editorRef) {
            // NOTE: Solution form https://github.com/quasarframework/quasar/blob/dev/docs/src/examples/QEditor/Pasting.vue
            // Let inputs do their thing, so we don't break pasting of links.
            if (evt.target.nodeName === 'INPUT')
                return;
            let text = '', onPasteStripFormattingIEPaste;
            evt.preventDefault();
            evt.stopPropagation();
            // handle paste depending on browser API
            if (evt.originalEvent && evt.originalEvent.clipboardData.getData) {
                // -> capture as plain text removing all formatting
                text = evt.originalEvent.clipboardData.getData('text/plain');
                // editorRef.runCmd('insertText', text)
                // -> capture as html code, send to server to strip html tags and attributes,
                // but keeping base formatting
                let textHtml = evt.originalEvent.clipboardData.getData('text/html');
                this.uiLoading();
                this.stripHtmlOnRemote(textHtml).then((textFormatted) => {
                    editorRef.runCmd('insertHTML', textFormatted);
                }).catch((err) => {
                    editorRef.runCmd('insertText', text); // on error paste plain text
                }).finally(() => {
                    this.uiLoading(false);
                });
            }
            else if (evt.clipboardData && evt.clipboardData.getData) { // Chrome
                // -> capture as plain text removing all formatting
                text = evt.clipboardData.getData('text/plain');
                // editorRef.runCmd('insertText', text)
                // -> capture as html code, send to server to strip html tags and attributes,
                // but keeping base formatting
                let textHtml = evt.clipboardData.getData('text/html');
                this.uiLoading();
                this.stripHtmlOnRemote(textHtml).then((textFormatted) => {
                    editorRef.runCmd('insertHTML', textFormatted);
                }).catch((err) => {
                    editorRef.runCmd('insertText', text); // on error paste plain text
                }).finally(() => {
                    this.uiLoading(false);
                });
            }
            else if (window.clipboardData && window.clipboardData.getData) { // IE
                // -> capture as plain text removing all formatting
                if (!onPasteStripFormattingIEPaste) {
                    onPasteStripFormattingIEPaste = true;
                    editorRef.runCmd('ms-pasteTextOnly', text);
                }
                onPasteStripFormattingIEPaste = false;
            }
        },
        async stripHtmlOnRemote(text) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('text', text);
                this.$axios.post(process.env.URL_API_REST + "/utils/strip_html", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': this.$store.getters['auth/token'] ? `Bearer ${this.$store.getters['auth/token']}` : null
                    }
                })
                    .then(function (transfer) {
                    resolve(transfer.data);
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
         * Force given content to be downloaded from browser to local host
         * @param filename    target file name (save as)
         * @param content     content to be saved
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        forceFileDownload(filename, content) {
            const blob = new Blob([content]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        },
        /**
         * Better search for ui objects lists (like select-boxes with input enabled)
         *
         * @param expression    search expression
         * @param set           name of array with all available options set
         * @param optionsArr    name of array where filtered options are placed
         * @param searchField   object field name to be searched
         */
        uiSelectSearch(expression, set, optionsArr, searchField = 'name') {
            if (!expression) {
                expression = '';
            }
            const v = (expression + ''); // make sure it's string
            const needle = v.toLowerCase();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this[optionsArr] = this[set] ? this[set].filter((obj) => {
                var _a;
                return ((_a = obj[searchField]) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(needle)) > -1;
            }) : [];
            return this[optionsArr];
            // TODO: use on all q - selects with input(search) feature
            // TODO: improve search (split search expression)
        },
        /** Style UI to loading state on/off
         *
         * @param status    if true put ui in "loading ..." status
         */
        async uiLoading(status = true) {
            this.$data.ui_Loading = status;
            await this.progressbar(status);
        }
    }
});
